import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import '@fontsource-variable/geist';
import './index.css';

import { createQueryClient } from '@/lib/query';
import { ThemeProvider } from '@/components/theme';
import { AppRoutes } from '@m/routes';

const queryClient = createQueryClient();

// Instead of pull to refresh: coming back to the app (from another app, or
// the phone waking) refetches whatever is on screen. Edits refresh their own
// data as they happen.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') void queryClient.invalidateQueries({ type: 'active' });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        {/* A pill 12pt above the tab bar (design canvas, DS-Patterns). */}
        <Toaster
          position="bottom-center"
          offset="calc(var(--tabbar-h) + var(--sab) + 12px)"
          mobileOffset={{ bottom: 'calc(var(--tabbar-h) + var(--sab) + 12px)' }}
          toastOptions={{
            classNames: {
              toast:
                'rounded-full border-0 bg-zinc-900 text-zinc-50 shadow-lg dark:bg-zinc-100 dark:text-zinc-900',
              description: 'opacity-70'
            }
          }}
        />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
